import Vue from 'vue'
import Router from 'vue-router'
import home from '@/modules/view/home/index.vue'
import business from '@/modules/view/business/index.vue'
import businessDetail from '@/modules/view/business/detail.vue'
import about from '@/modules/view/about/index.vue'
import person from '@/modules/view/about/person.vue'
import joinUs from '@/modules/view/joinUs/index.vue'

import detail from '@/modules/view/case/detail.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/business',
      name: 'business',
      component: business
    },
    {
      path: '/businessDetail/:id',
      name: 'businessDetail',
      component: businessDetail
    },
    {
      path: '/case',
      name: 'case',
      component: home
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/person/:id',
      name: 'person',
      component: person
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: detail
    },
    {
      path: '/*',
      name: 'other',
      component: home
    },
  ]
})



// WEBPACK FOOTER //
// ./src/modules/router/index.js